module.exports = __webpack_public_path__ + "img/Wildfire.6093d0dc.jpg";